export const combineFoodsAndFoodGroupsIntoIndex = (foods, foodGroups) => {
    const allFoods = [
        ...foods.map(food => ({ food, displayName: food.name })),
        ...foodGroups.flatMap(fg => fg.foods.map(food => ({ food, displayName: fg.name }))),
    ];
    const initDict = {};
    const foodsIndex = allFoods.reduce((acc, { food, displayName }) => ({
        ...acc,
        [food.id]: (acc[food.id] || new Set()).add(displayName),
    }), initDict);
    return foodsIndex;
};
//# sourceMappingURL=utils.js.map